<template>

  <div class="builderbar" data-breakmax="mama" v-if="builder.mode == 'build'">

    <div class="builderbar-btn-wrapper" data-id="gotoOverview">
      <button class="builderbar-button l_left" @click.stop="gotoOverview">
        <span class="visually-hidden">Jump to Overview</span>
        <svg class="icon"><use href="#layout"></use></svg>
      </button>
    </div>

    <div class="progressbar">
      <div class="progressbar-bar">
        <div class="progressbar-done" :data-status="progressBarStatus" :style="`width: ${builder.currentItem.percentage}%;`" v-if="builder.currentItem">
          <div class="progressbar-num"><span v-html="builder.currentItem.percentage ?? 0"></span>%</div>
        </div>
      </div>
    </div>

    <button class="builderbar-button l_right" v-if="builder.step > 1 || builder.items.length > 1" @click.stop="builder.setMode('quote')">
      <span class="visually-hidden">View Quote</span>
      <svg class="icon"><use href="#cart"></use></svg>
    </button>

  </div>

  <div class="builderbar" data-breakmax="mama" v-else-if="builder.mode == 'quote'">

    <button class="builderbar-button l_expanded l_grey" @click.stop="builder.scrollToRef('quoteTotals')">
      <span class="text">Totals</span>
      <svg class="icon"><use href="#cart"></use></svg>
    </button>

    <div class="builderbar-text" v-html="builder.quote.totalCost"></div>

    <button class="builderbar-button l_expanded" :class="{ 's_disabled' : ( (builder.step >= builder.stepValid) || !builder.quote.deliveryType || !builder.quote.valid ) }" @click.stop="orderNow($event)">
      <span class="text">Order</span>
      <svg class="icon"><use href="#arrow-right"></use></svg>
    </button>

    <!-- <button class="builderbar-button l_right" @click.stop="builder.setMode('quote')">
      <span class="visually-hidden">View Quote</span>
      <svg class="icon"><use href="#cart"></use></svg>
    </button> -->

  </div>

  <div class="builderbar2" data-breakmax="mama" v-if="builder.mode == 'build'">

    <button class="builderbarbtn" @click.stop="gotoOverview">
      <div class="builderbarbtn-icon">
        <!-- <svg class="icon"><use href="#check"></use></svg> -->
        <div class="progressbar l_micro">
          <div class="progressbar-bar">
            <div class="progressbar-done" :data-status="progressBarStatus" :style="`width: ${builder.currentItem.percentage}%;`" v-if="builder.currentItem">
            </div>
          </div>
        </div>
      </div>
      <div class="builderbarbtn-title">
        <span v-html="builder.currentItem.percentage ?? 0"></span>%
      </div>
    </button>

    <button class="builderbarbtn" @click.stop="showSummary" v-if="builder.mode == 'build'">
      <div class="builderbarbtn-icon">
        <svg class="icon"><use href="#layout"></use></svg>
      </div>
      <div class="builderbarbtn-title">My <span v-html="builder.currentProductHandle"></span></div>
    </button>

    <!-- <button class="builderbarbtn" @click.stop="gotoDesign" v-if="builder.mode == 'build' && builder.step == 3">
      <div class="builderbarbtn-icon">
        <svg class="icon"><use href="#design"></use></svg>
      </div>
      <div class="builderbarbtn-title">Design</div>
    </button> -->

    <a href="/builder/save/" class="builderbarbtn" v-if="builder.mode == 'quote'">
      <div class="builderbarbtn-icon">
        <svg class="icon"><use href="#email"></use></svg>
      </div>
      <div class="builderbarbtn-title">Save</div>
    </a>

    <button class="builderbarbtn" @click.stop="builder.setMode('quote')" v-if="builder.mode == 'build' && !builder.quote.valid">
      <div class="builderbarbtn-icon">
        <svg class="icon"><use href="#cart"></use></svg>
      </div>
      <div class="builderbarbtn-title">Quote</div>
    </button>

    <a href="/support/" target="_blank" class="builderbarbtn" v-else>
      <div class="builderbarbtn-icon">
        <svg class="icon"><use href="#help"></use></svg>
      </div>
      <div class="builderbarbtn-title">Help</div>
    </a>

    <button class="builderbarbtn" @click.stop="saveAndContinue($event)" v-if="builder.mode == 'build' && builder.step < builder.stepMax+1">
      <template v-if="builder.isSubmitted">
        <div class="builderbarbtn-icon">
          <svg class="circular-loader" viewBox="10 10 20 20" >
            <circle class="loader-path" cx="20" cy="20" r="8" fill="none" stroke="#ffffff" stroke-width="2" />
          </svg>
        </div>
        <div class="builderbarbtn-title">Loading</div>
      </template>
      <template v-else>
        <div class="builderbarbtn-icon">
          <svg class="icon"><use href="#arrow-right"></use></svg>
        </div>
        <div class="builderbarbtn-title">Continue</div>
      </template>
    </button>

    <button class="builderbarbtn" :class="{ 's_disabled' : ( (builder.step >= builder.stepValid) || !builder.quote.deliveryType || !builder.quote.valid ) }" @click.stop="orderNow($event)" v-if="builder.mode == 'quote'">
      <div class="builderbarbtn-icon">
        <svg class="icon"><use href="#cart"></use></svg>
      </div>
      <div class="builderbarbtn-title">Order</div>
    </button>

  </div>

</template>

<script setup>

import { reactive, computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['saveAndContinue'])

const progressBarStatus = computed(() => {
  return (builder.currentItem.percentage ?? 0) < 30 ? 'low' : 'high';
})

function gotoOverview() {
  builder.scrollToRef('builderTop');
}

function gotoDesign() {
  builder.scrollToRef('sectionsOverviewGroup');
}

function showSummary() {
  builder.showSummary = true;
}

function orderNow(e) {
  emit('orderNow', e);
}

function saveAndContinue(e) {
  emit('saveAndContinue', e);
}
</script>
